// Make URL friendly & kebab-case
const slugify = string => {
  // https://gist.github.com/hagemann/382adfc57adbd5af078dc93feef01fe1
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};

// oa/track/
const tracksRootUrl = `/oa/tracks/`;

// Tutorial: tutorials/
// OA-Tutorial: oa/tutorials/
// OA-Track: oa/track/[track slug]/
const tutorialsRootUrl = ({legacy, track}) => {
  if (legacy) {
    if (track?.slug) {
      return `${tracksRootUrl}${track.slug}/`;
    }
    return `/oa/tutorials/`;
  }
  return `/tutorials/`;
};

// Tutorial: tutorials/[tutorial slug]/
// OA-Tutorial: oa/tutorials/[tutorial slug]/
// OA-Track: oa/track/[track slug]/[tutorial slug]/
const rootTutorialUrl = ({tutorial, legacy, track}) =>
  `${tutorialsRootUrl({legacy, track})}${tutorial.slug}/`;

// Tutorial: tutorials/[tutorial slug]/[first page slug]/
// OA-Tutorial: oa/tutorials/[tutorial slug]/[first page slug]/
// OA-Track: oa/track/[track slug]/[tutorial slug]/[first page slug]/
const tutorialUrl = ({tutorial, legacy, track}) =>
  `${rootTutorialUrl({tutorial, legacy, track})}${tutorial.pages.nodes[0].slug}/`;

// Tutorial: tutorials/[tutorial slug]/[page slug]/
// OA-Tutorial: oa/tutorials/[tutorial slug]/[page slug]/
// OA-Track: oa/track/[track slug]/[tutorial slug]/[page slug]/
const tutorialPageUrl = ({tutorial, page, legacy, track}) =>
  `${rootTutorialUrl({tutorial, legacy, track})}${page.slug}/`;

// Title slugified to kebab-case
const tutorialSectionAnchor = section => `Section-${slugify(section.title)}`;

// Tutorial: tutorials/[tutorial slug]/[page slug]/#[section-anchor]
// OA-Tutorial: oa/tutorials/[tutorial slug]/[page slug]/#[section-anchor]
// OA-Track: oa/track/[track slug]/[tutorial slug]/[page slug]/#[section-anchor]
const tutorialSectionUrl = ({tutorial, page, section, legacy, track}) =>
  `${tutorialPageUrl({tutorial, page, legacy, track})}#${tutorialSectionAnchor(section)}`;

module.exports = {
  slugify,
  tracksRootUrl,
  tutorialsRootUrl,
  rootTutorialUrl,
  tutorialUrl,
  tutorialPageUrl,
  tutorialSectionAnchor,
  tutorialSectionUrl,
};
